import ProviderDetails from "./details"
import { Consumer, Provider, ProviderDetailsContext } from "./details.context"

export { Consumer, Provider, ProviderDetailsContext }
export default ProviderDetails
